import { NotepadText } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';

type Props = {
    notes: string | null | undefined;
    className?: string;
};

export function ContactNotes({ notes, className }: Props) {
    const text = notes?.trim();
    if (!text) return null;

    return (
        <div className={cn('flex items-start gap-2 text-sm text-muted-foreground', className)}>
            <NotepadText aria-hidden className="mt-0.5 size-4 shrink-0" />
            <p className="min-w-0 break-words whitespace-pre-line">{text}</p>
        </div>
    );
}
